export default function Footer() {
    return(
        <div className="bg-gray-700 absolute inset-x-0 bottom-0 left-0 w-full text-gray-300">
            <div className="container mx-auto md:grid grid-cols-3 text-sm pb-3 pt-20">
                <div className="text-center lg:hidden mb-10 col-span-3">
                    <p className="text-xl text-blue-700 mb-3 uppercase">Contact us</p>
                    <div>SG HRM Solutions <br /> 4/4, Kannaiah street <br /> Aminjikarai <br /> Chennai - 600029 <br /> <br />
                    </div>
                </div>
                <p className="text-center sm:float-left mt-auto">
                    Copy Rigths © 2021 SG HRM Solutions
                </p>
                <div>
                    <div className="text-center mt-auto">
                        <p className="text-xl  hidden lg:block text-blue-700 uppercase">Contact us</p>
                        <div className=" hidden lg:block">SG HRM Solutions <br /> 4/4, Kannaiah street <br /> Aminjikarai <br /> Chennai - 600029 <br /> <a href="mailto:sghrmsolutions@gmail.com" className="underline">sghrmsolutions@gmail.com</a>
                        </div>
                    </div>
                </div>
                <p className="text-center sm:float-right mt-auto">
                    Created by VTV Creations
                </p>
            </div>
        </div>
    )
}